export default "__VITE_ASSET__B41HvJcz__"